export default "__VITE_ASSET__BcPQIOai__"